
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class couponItem extends Vue {
  @Prop({ default: () => {} }) data: any;
  @Prop({ default: false }) isBatch: boolean;

  // handleCouponDetail() {
  //   this.$router.push({
  //     path: "/couponDetail",
  //     query: {
  //       id: this.data.id,
  //     },
  //   });
  // }
  getStatus(status: any) {
    return status === 1 ? '未领取' : status === 2 ? '已领取' : status === 3 ? '已核销' : status === 4 ? '已过期' : '已作废'
  }
}
